import { useAuth } from '../context/AuthContext/AuthContext';
import { isImpersonating } from '../utils/impersonationSession';

/**
 * Hook to determine if tracking (pixels, analytics) should be enabled.
 * Returns false for admin users or admin view to avoid polluting analytics data.
 */
export const useTrackingEnabled = (): boolean => {
  const { user } = useAuth();

  // Don't load pixels until we know who the user is
  if (!user) {
    return false;
  }

  // Disable tracking for admin users or admin viewing a user's account
  if (user.role === 'ROLE_ADMIN' || isImpersonating()) {
    return false;
  }

  return true;
};

export default useTrackingEnabled;
